/* eslint-disable @typescript-eslint/no-explicit-any */
import {sentryCaptureMessageFiltered} from '@src/utility/sentry'

import {EVENT_TAGS, LOG_TAGS} from '../type'
import {LoggerStrategyConstructor, LoggerStrategyType, LoggerUser, LogLevel} from './type'

export class LoggerStrategy {
  private readonly logStrategies: LoggerStrategyType[]

  constructor(logStrategies: LoggerStrategyConstructor[]) {
    this.logStrategies = logStrategies.filter(logger => logger.enabled).map(logger => logger.class)
  }

  async init() {
    await Promise.all(this.logStrategies.map(strategy => strategy.init?.()))
  }

  event<T extends keyof EVENT_TAGS>(name: T, properties?: EVENT_TAGS[T]) {
    try {
      this.logStrategies.forEach(strategy => strategy.event?.(name, properties))
    } catch (e) {
      sentryCaptureMessageFiltered(e as Error, 'LoggerStrategy event error')
    }
  }

  log(name: LOG_TAGS, properties?: Record<string, any>, level: LogLevel = 'info') {
    try {
      this.logStrategies.forEach(strategy => strategy.log?.(name, properties, level))
    } catch (e) {
      sentryCaptureMessageFiltered(e as Error, 'LoggerStrategy log error')
    }
  }

  setUser(properties: LoggerUser) {
    if (!properties) return

    this.logStrategies.forEach(strategy => strategy.setUser?.(properties))
  }

  resetUser() {
    try {
      this.logStrategies.forEach(strategy => strategy.resetUser?.())
    } catch (e) {
      sentryCaptureMessageFiltered(e as Error, 'LoggerStrategy resetUser error')
    }
  }
}
